import * as types from '../mutation-types'
import Pusher from 'pusher-js'
import { config, isProduction } from './../../config'
import { bindEvents } from 'utils/pusher'

const state = {
	loading: false,
  eventLoading: false,
	title: null,
  pusher: null,
}

const mutations = {
	[types.SET_LOADING](state, loading) {
		state.loading = loading;
	},
  [types.SET_EVENT_LOADING](state, loading) {
    state.eventLoading = loading;
  },
	[types.SET_TITLE](state, title) {
		state.title = title;
	},
  [types.INIT_PUSHER](state, id) {
  	Pusher.logToConsole = !isProduction;

    state.pusher = new Pusher(config.PUSHER_KEY, {
      cluster: 'ap1',
      encrypted: true
    });

    bindEvents(state.pusher.subscribe(`user-${id}`));
  }
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js